<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <div class="row">
              <span>表現・文型</span>
              <v-spacer />
              <!-- add legal information-->
              <v-btn
                :to="{
                  name: 'Add Expression OF Section',
                  params: {
                    chapter: $route.params.chapter,
                    section: $route.params.section,
                  },
                  query: { no: listExpression.length + 1 },
                }"
                class="mx-3"
                small
                color="primary"
                >追加</v-btn
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <v-data-iterator
              :items-per-page.sync="listExpression.length"
              :items="listExpression"
              :loading="loadingListExpression"
              hide-default-footer
            >
              <template v-slot:default="props">
                <v-row>
                  <v-col
                    v-for="(item, index) in props.items"
                    :key="index"
                    cols="2"
                    class="card-list"
                  >
                    <v-card color="#f5f5f5">
                      <v-card-text class="align-start pt-3 pb-2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <template class="d-inline-block text-truncate mt-1">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="d-inline-block text-truncate px-2"
                                style="max-width: 180px"
                                >{{ findValueName(item.data) }}</span
                              >
                            </template>
                          </template>
                          <span
                            class="px-2"
                            style="max-width: 130px"
                            v-text="findValueName(item.data)"
                          />
                        </v-tooltip>
                        <div class="row pa-0 ma-0">
                          <div class="icon-trash">
                            <v-icon
                              size="medium"
                              @click="
                                $router.push({
                                  name: 'Update Expression OF Section',
                                  params: {
                                    chapter: $route.params.chapter,
                                    section: $route.params.section,
                                    expression: item.Id,
                                  },
                                  query: { no: index + 1 },
                                })
                              "
                              v-text="`fas fa-pencil-alt`"
                              class="mr-3"
                            />
                            <DeleteItemGrammar
                              :item="item"
                              @resetList="handleGetlistExpression"
                            />
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:loading>
                <div class="text-center mt-5">
                  読み込み中。。。待ってください。
                </div>
              </template>
              <template v-slot:no-data>
                <div class="text-center">データがありません。</div>
              </template>
            </v-data-iterator>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
import { getListExpression } from "@/api/Expression.api";
import DeleteItemGrammar from "./DeleteExpression";
export default {
  store: ["editDetailSection"],
  components: {
    DeleteItemGrammar,
  },
  data() {
    return {
      listExpression: [],
      loading: false,
      loadingListExpression: false,
    };
  },
  created() {
    this.handleGetlistExpression();
  },

  watch: {
    $route: function () {
      this.handleGetlistExpression();
    },
  },
  methods: {
    async handleGetlistExpression() {
      this.loadingListExpression = true;
      let params = {
        keyword: "",
        sub_key: this.$route.params.section,
      };
      await getListExpression(params)
        .then(({ result }) => {
          this.listExpression = result;
        })
        .catch((error) => {
          console.log(error);
          this.loadingListExpression = false;
        });
      this.loadingListExpression = false;
    },
    findValueName(data) {
      console.log("data: ", data);
      var name = "";
      this._.forEach(data, (e) => {
        if (e.key == "FormTitle") {
          this._.forEach(e.data, (i) => {
            if (i.key == "Title") {
              name += i.value.ja;
            }
          });
        }
      });
      return name;
    },
  },
};
</script>
<style  scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>